import { render } from "./HerosPart.vue?vue&type=template&id=0bb9cd08&scoped=true"
import script from "./HerosPart.vue?vue&type=script&lang=js"
export * from "./HerosPart.vue?vue&type=script&lang=js"

import "./HerosPart.vue?vue&type=style&index=0&id=0bb9cd08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb9cd08"]])

export default __exports__